export type ProductVariant = "melco" | "bernina";

export const useCurrentProductVariant = () => {
  const configuredProductVariant = process.env.REACT_APP_PRODUCT_VARIANT!;
  const allowedProductVariants = ["melco", "bernina"];
  if (allowedProductVariants.includes(configuredProductVariant)) {
    return configuredProductVariant as ProductVariant;
  }

  throw new Error(
    `Product variant incorrectly configured (${configuredProductVariant})`
  );
};
